//libs
import React, { useState } from "react";
import { withSnackbar } from "notistack";

//constants
import { FORM_TYPES, NOTIFICATION_TYPES, STRINGS } from "src/shared/constants";

//styles
import S from "./style.module.scss";

//components
import { BreadcrumbMenu } from "src/components";
import { AddNotificationForm } from "../AddNotificationForm";

const PushNotifications = ({
  enqueueSnackbar = () => {},
  sendNotification = () => {},
}) => {
  const [formStates, setFormStates] = useState({});

  const initialFormStates = {
    formData: {},
    formViewType: FORM_TYPES.add,
  };

  const handleFormClose = (callback) => {
    callback();
  };

  const handleSubmit = async (values, resetForm) => {
    handleAddNotification(values, resetForm);
  };

  const handleAddNotification = (values, resetForm = () => {}) => {
    sendNotification({
      payload: {
        notificationMessage: values.message,
        notificationType: NOTIFICATION_TYPES.PUSH,
      },
      success: (msg) => {
        enqueueSnackbar(msg, { variant: "success" });
        setFormStates(initialFormStates);
        resetForm();
      },
      fail: (msg) => {
        enqueueSnackbar(msg, { variant: "error" });
      },
    });
  };

  return (
    <section className={S.section}>
      <BreadcrumbMenu
        title={STRINGS.CONFIGURE}
        subTitle={STRINGS.PUSH_NOTIFICATIONS}
      ></BreadcrumbMenu>

      <AddNotificationForm
        formData={formStates.formData}
        formType={formStates.formViewType}
        handleCancel={handleFormClose}
        onSubmit={handleSubmit}
      />
    </section>
  );
};

export default withSnackbar(PushNotifications);
